export default __webpack_public_path__ + "static/HKGrotesk-ExtraBold-6cda7251b6de3cce3d0e57d7d5b9f209.woff";